import CheckoutPage from 'pages/CheckoutPage/CheckoutPage';
import QuotationCheckoutPage from 'pages/QuotationCheckoutPage/QuotationCheckoutPage';
import { useIsQuotationMode } from 'utils/hooks/useIsQuotationMode';

const DetailsTab = () => {
  const isQuotationMode = useIsQuotationMode();

  return isQuotationMode ? <QuotationCheckoutPage /> : <CheckoutPage />;
};

export default DetailsTab;
